export const ROUTE_PATH = '/parking-whitelist';

export const FEATURE_NAME = 'parkingWhitelistPage';
